<a
  class="appstore-btn"
  href="https://apps.apple.com/de/app/daydic/id1531175789?l=en-GB"
  rel="noopener noreferrer"
  target="_blank"
>
  <svg class="apple-icon" viewBox="0 0 814 1000" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.5-155.5-127.4C46 790.7 0 663 0 541.8c0-207.5 135.4-317.3 269-317.3 70.1 0 128.4 46.4 172.5 46.4 42.8 0 109.6-49 191.4-49 30.9 0 110.1 2.6 167.3 99.1zm-234.7-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"
      fill="white"
    />
  </svg>
  <span class="appstore-btn-text">Download on the <strong>App Store</strong></span>
</a>
